import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ISelectOption } from '../../../common';
import { LsqBasePaginationComponent } from '../base-pagination/lsq-base-pagination.component';

@Component({
    selector: 'lsq-data-table-pagination',
    styleUrls: ['./lsq-data-table-pagination.component.scss'],
    template: `
        <div class="lsq-data-table-pagination" [class.isLoading]="isLoading">
            <div class="pagination-content">
                <lsq-select
                    [disabled]="disableTakeSelect"
                    [name]="'data-table-pagination-select'"
                    [ngModel]="take"
                    [options]="takeSelectOptions"
                    [dropUp]="true"
                    (blur)="markForCheck()"
                    (ngModelChange)="handleTakeChange($event)"
                >
                </lsq-select>
                <span class="results-count">
                    <span i18n>Of</span>
                    {{ totalCount | number }}
                    <span *ngIf="totalCount !== 1" i18n>Results</span>
                    <span *ngIf="totalCount === 1" i18n>Result</span>
                </span>
            </div>
            <div class="pagination-content">
                <lsq-button
                    id="previous-page-button"
                    [style.marginRight]="'2rem'"
                    appearance="secondary"
                    [disabled]="currentPage === 1"
                    (buttonClick)="incrementPage(paging.prev)"
                    i18n
                >
                    Back
                </lsq-button>
                <lsq-page-input
                    id="current-page-number"
                    [style.marginRight]="'2rem'"
                    inputClass="paging-input"
                    [min]="1"
                    [max]="pageCount"
                    (pageUpdated)="handlePageChange($event)"
                    [ngModel]="currentPage"
                >
                </lsq-page-input>
                <lsq-button
                    id="next-page-button"
                    appearance="secondary"
                    [disabled]="currentPage === pageCount || pageCount === 0"
                    (buttonClick)="incrementPage(paging.next)"
                    i18n
                >
                    Next
                </lsq-button>
            </div>
        </div>
    `
})
export class LsqDataTablePaginationComponent extends LsqBasePaginationComponent implements OnInit {
    private _showing = this._i18n('Showing');
    public takeSelectOptions: ISelectOption[];
    @Input() public disableTakeSelect = false;

    constructor(private _changeDetectorRef: ChangeDetectorRef, private _i18n: I18n) {
        super();
    }

    public ngOnInit(): void {
        this.takeSelectOptions = this.takeOptions.map((option) => ({
            value: option,
            selectedLabel: `${this._showing} ${option}`,
            label: option.toString()
        }));
    }

    public markForCheck(): void {
        this._changeDetectorRef.markForCheck();
    }
}
